import React from 'react';

const G = '#8892A4';

export const PRIORITY_CONFIG = {
  1: { label: 'Priorité 1', dot: '#ef4444', text: 'Contacté·e en premier' },
  2: { label: 'Priorité 2', dot: '#f59e0b', text: 'Contacté·e si P1 ne répond pas' },
  3: { label: 'Priorité 3', dot: '#6b7280', text: 'Contacté·e en dernier recours' },
};

const PrioritySelector = ({ value, onChange }) => (
  <div>
    <div
      role="radiogroup"
      aria-label="Priorité du bénéficiaire"
      style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}
    >
      {[1, 2, 3].map(n => {
        const cfg = PRIORITY_CONFIG[n];
        const active = value === n;
        return (
          <button
            key={n}
            type="button"
            role="radio"
            aria-checked={active}
            tabIndex={0}
            onClick={() => onChange(n)}
            onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onChange(n); } }}
            style={{
              flex: 1,
              minWidth: 100,
              padding: '10px 0',
              borderRadius: 20,
              fontSize: 13,
              fontWeight: active ? 700 : 400,
              cursor: 'pointer',
              border: active ? `1px solid ${cfg.dot}` : '1px solid rgba(255,255,255,0.08)',
              background: active ? `${cfg.dot}22` : 'rgba(255,255,255,0.04)',
              color: active ? cfg.dot : G,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 6,
              transition: 'all 0.15s ease',
            }}
          >
            <span style={{ width: 7, height: 7, borderRadius: '50%', background: cfg.dot, display: 'inline-block', flexShrink: 0 }} />
            P{n}
          </button>
        );
      })}
    </div>

    {/* Sous-texte — Variante A : 3 lignes statiques */}
    <div style={{ marginTop: 10 }}>
      {[1, 2, 3].map(n => (
        <div key={n} style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 3 }}>
          <span style={{ width: 6, height: 6, borderRadius: '50%', background: PRIORITY_CONFIG[n].dot, display: 'inline-block', flexShrink: 0 }} />
          <span style={{ fontSize: 12, color: n === value ? 'rgba(255,255,255,0.65)' : 'rgba(255,255,255,0.25)' }}>
            <strong>P{n}</strong> — {PRIORITY_CONFIG[n].text}
          </span>
        </div>
      ))}
    </div>
  </div>
);

export default PrioritySelector;
